import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import { XCircle } from "lucide-react";

const CheckoutCancelPage = () => {
  return (
    <div className="min-h-screen bg-[#050508]" data-testid="checkout-cancel-page">
      <Navbar />

      <main className="pt-24 pb-20 flex items-center justify-center min-h-screen">
        <div className="max-w-lg w-full mx-auto px-4">
          <div className="text-center bg-[#0a0a12] border border-white/5 p-12">
            <div className="w-20 h-20 bg-[#A1A1AA]/20 flex items-center justify-center mx-auto mb-6">
              <XCircle className="w-12 h-12 text-[#A1A1AA]" />
            </div>
            <h1 className="font-heading text-2xl text-white mb-4">Payment Cancelled</h1>
            <p className="text-[#A1A1AA] mb-8">
              Your payment was cancelled. No charges were made to your account.
            </p>
            <div className="flex gap-4">
              <Link to="/products" className="btn-primary flex-1" data-testid="browse-products">
                Browse Products
              </Link>
              <Link to="/" className="btn-secondary flex-1">
                Go Home
              </Link>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default CheckoutCancelPage;
